<mat-toolbar class='app-nav' color="primary">
  <!-- <img src="../../assets/icons/icon-72x72.png"> -->
  <h1 routerLink="/" title="jeans {{ version }}">
    {{title}}
  </h1>
  <span class="spacer"></span>
  @if (authed() && userImage()) {
    <div class="user-icon">
      <img [src]="userImage()!" (error)="onImageError($event)">
    </div>
  }
  <button align="right" mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
</mat-toolbar>


<mat-menu #menu="matMenu">

  <!-- <button *ngIf="authed" mat-menu-item routerLink="/">
  <mat-icon>dialpad</mat-icon>
  <span>home</span>
</button> -->

<!-- <button *ngIf="authed" mat-menu-item routerLink="/motoko">
<mat-icon>phone_android</mat-icon>
<span>motoko</span>
</button> -->

@if (authed()) {
  <button mat-menu-item routerLink="/owntracks">
    <mat-icon>room</mat-icon>
    <span>owntracks</span>
  </button>
}

@if (authed()) {
  <button mat-menu-item routerLink="/shib">
    <mat-icon>trending_up</mat-icon>
    <span>Shib</span>
  </button>
}

@if (authed()) {
  <button mat-menu-item routerLink="/deck">
    <mat-icon>highlight</mat-icon>
    <span>Deck</span>
  </button>
}

<!-- <button *ngIf="authed" mat-menu-item routerLink="/tracker">
<mat-icon>room</mat-icon>
<span>tracker</span>
</button> -->

<!-- <button *ngIf="authed" mat-menu-item routerLink="/humans">
<mat-icon>security</mat-icon>
<span>humans</span>
</button> -->

<!-- <button *ngIf="authed" mat-menu-item routerLink="/styles">
<mat-icon>security</mat-icon>
<span>styles</span>
</button> -->

<!-- <button *ngIf="authed" mat-menu-item routerLink="/overwatch">
<mat-icon>watch</mat-icon>
<span>overwatch</span>
</button> -->

<!-- <button *ngIf="authed" mat-menu-item routerLink="/house">
<mat-icon>home</mat-icon>
<span>House</span>
</button> -->

@if (authed()) {
  <button mat-menu-item routerLink="/office">
    <mat-icon>home</mat-icon>
    <span>Office</span>
  </button>
}

<!-- <button *ngIf="authed" mat-menu-item routerLink="/eyes">
<mat-icon>settings_overscan</mat-icon>
<span>Eyes</span>
</button> -->

<!-- <button *ngIf="authed" mat-menu-item routerLink="/lights">
<mat-icon>brightness_4</mat-icon>
<span>Lights</span>
</button> -->

@if (authed()) {
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit to app</mat-icon>
    <span>Logout</span>
  </button>
}

</mat-menu>
